.toggle {
	--track-width: 28px;
	--track-height: 16px;
	--track-padding: 2px;
	--track-radius: 300px;
	--track-color-off: #818181;
	--track-color-on: #1087a1;
	--track-color-disabled-off: #616161;
	--track-color-disabled-on: #b0cbd1;

	--knob-size: 13px;
	--knob-color: #ffffff;
	--knob-color-disabled: #b7b7b7;
	--knob-shadow: 0px 0px 3px 0px #00000026;

	--transition-duration: 0.3s;

	position: relative;
	display: inline-block;
	width: var(--track-width);
	height: var(--track-height);
	border: none;
	border-radius: var(--track-radius);
	background-color: var(--track-color-off);
	cursor: pointer;
	transition: background-color var(--transition-duration) ease;
	padding: 0;
}

.toggle[aria-pressed="true"] {
	background-color: var(--track-color-on);
}

.toggle:disabled {
	cursor: not-allowed;
	opacity: 0.6;
	background-color: var(--track-color-disabled-off);
}

.toggle[aria-pressed="true"]:disabled {
	background-color: var(--track-color-disabled-on);
}

.knob {
	position: absolute;
	top: calc((var(--track-height) - var(--knob-size)) / 2);
	left: var(--track-padding);
	width: var(--knob-size);
	height: var(--knob-size);
	border-radius: 50%;
	background-color: var(--knob-color);
	box-shadow: var(--knob-shadow);
	transition:
		transform var(--transition-duration) ease,
		background-color var(--transition-duration) ease;
	pointer-events: none;
}

.toggle[aria-pressed="true"] .knob {
	transform: translateX(calc(var(--track-width) - var(--knob-size) - (2 * var(--track-padding))));
}

.toggle:disabled .knob {
	background-color: var(--knob-color-disabled);
}

.toggle:focus {
	outline: 2px solid #0b6f85;
	outline-offset: 2px;
}
